module.exports = __webpack_public_path__ + "img/admin_panel_settings_opsz24.3f404c71.svg";